// extracted by mini-css-extract-plugin
export default {"item-in-order-table-prop-65-warining__button":"item-in-order-table-prop-65-warining__button_eP6ElGgW"};